module.exports = __webpack_public_path__ + "icon-alertminer-mileage.d573ac4c77f8936bc987.png";